export default {
  STEP_1: {
    TITLE: 'Upload constitutional documents',
    SUBTITLE: 'Constitutional documents',
    DESCRIPTION: 'This should include all documents related to the incorporation of your company, for example:',
    TOOLTIP1: 'Upload all of your documents for this company. These documents will be safely stored in your data room.',
  },
}